import { Image } from '../types'

const sortImagesByOrdinality = (images: Image[]): Image[] => {
  return [...images].sort((a, b) => {
    const ordinalityDiff = (a.ordinality ?? 0) - (b.ordinality ?? 0)
    if (ordinalityDiff !== 0) return ordinalityDiff
    return a.id - b.id
  })
}

export { sortImagesByOrdinality }
